import api, { apiPrefix } from './Api';

const authApiPrefix = `${apiPrefix}/auth/`;

export const login = async (
  username: string,
  password: string,
): Promise<string> => {
  const response = await api.post(`${authApiPrefix}login`, {
    email: username,
    password,
  });

  const token = response.data?.access_token;
  if (!token) {
    throw new Error('Could not login: empty token received from the API');
  }

  return token;
};
